module.exports = __webpack_public_path__ + "static/media/OurMission.874b3073.png";